import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import EmptyStates from '../../../common/components/empty-states';
import withTranslate from '../../../common/hoc/with-translate';
import { requestLogin } from '../../../common/services/request-login';
import styles from './sign-up.scss';
import { getAllExperiments } from '../../../common/state/site/selectors';
import { State } from '../../../about/typings';

interface SignUpProps {
  t: TranslationFunction;
  experiments: Record<string, 'true' | 'false'>;
}

const SignUp: React.FC<SignUpProps> = ({ t }) => (
  <EmptyStates title={t('sign-up.title')} content={t('sign-up.content')}>
    <button
      onClick={requestLogin}
      className={classNames(styles.signUpButton, 'ma-primary-button')}
      data-hook="loginButton"
    >
      {t('sign-up.action')}
    </button>
  </EmptyStates>
);

const mapStateToProps = (state: State) => ({
  experiments: getAllExperiments(state),
});

export default connect(mapStateToProps)(withTranslate(SignUp));
